import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  description?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, description, id, ...props }, ref) => {
    const generatedId = React.useId()
    const textareaId = id ?? (label ? generatedId : undefined)

    return (
      <div className="flex flex-col gap-1.5 w-full">
        {label && (
          <label
            htmlFor={textareaId}
            className="text-sm font-medium leading-none text-black/96"
          >
            {label}
          </label>
        )}
        <textarea
          id={textareaId}
          data-slot="textarea"
          className={cn(
            "min-h-[80px] w-full min-w-0 rounded-md border bg-white px-4 py-1 text-sm text-black/45",
            "shadow-xs transition-[color,box-shadow] outline-none resize-vertical",
            "border-base-border",
            "placeholder:text-black/45",
            "focus-visible:ring-[3px] focus-visible:ring-custom-outline/50 focus-visible:border-custom-outline",
            "disabled:pointer-events-none disabled:cursor-not-allowed disabled:text-base-border",
            "aria-invalid:border-custom-destructive-dark",
            "aria-invalid:focus-visible:ring-[3px] aria-invalid:focus-visible:ring-custom-destructive-dark/50 aria-invalid:focus-visible:border-custom-destructive-dark",
            className
          )}
          ref={ref}
          {...props}
        />
        {description && (
          <p className="text-sm leading-[1.25rem] text-black/65">
            {description}
          </p>
        )}
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
